export const GET_TEAM_MEMBERS = "GET_TEAM_MEMBERS";
export const GET_TEAM_MEMBER_BY_ID = "GET_TEAM_MEMBER_BY_ID";
export const UPDATE_TEAM_MEMBER = "UPDATE_TEAM_MEMBER";
export const DELETE_TEAM_MEMBER = "DELETE_TEAM_MEMBER";
export const CREATE_TEAM_MEMBER = "CREATE_TEAM_MEMBER";
